import gql from 'graphql-tag';

export const USER_MINI_FRAGMENT = gql`
    fragment FUserMiniInfo on UserMiniInfo {
        userId
        imageUrl
        backgroundUrl
    }
`;

export const USER_FRAGMENT = gql`
    fragment FUser on User {
        userId
        role
        imageUrl
        email
        userAccessLevel
        currentPeriodViews
        hasSubscription
        hasActiveSubscription
        subscriptionDetailStatus
        subscriptionTier
        categoryImages
        promotionActions {
            promotionId
            action
        }
        hasPassword
    }
`;
